module.exports = __webpack_public_path__ + "static/media/stars.8cc26363.svg";